<template>
    <div class="page_box">
        
      <div class="page_table_box">
        <div class="school_table_box">
          <el-table
            :data="tableData"
            height="500px"
            class="table_box"
            
            :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          >
            
            <el-table-column
              prop="userName"
              label="参会人员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="schoolName"
              label="学校名称"
              align="center"
            ></el-table-column>
            
            <el-table-column
              prop="cloudMeetingRecordsTime"
              label="参会时间"
              align="center"
            >
            <template v-slot='scope'>
           {{timeFormate(scope.row.cloudMeetingRecordsTime*1000)   }}
              <!-- {{scope.row.lectureClass}}小时 -->
              </template>
          </el-table-column>
        
            
          </el-table>
        </div>
        <div class="pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="requestData.pageNum"
            :page-size="requestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
     
    </div>
  </template>
  
  <script>
  import { Form } from 'element-ui';
  //这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
  //列如：import <<组件名称>> from '《组件路径》';
  export default {
    //import引入的组件需要注入到对象中才能使用
    name: "prelectionRecord",
    components: {
      
    },
    props: {},
    data() {
      //这里存放数据
      return {
        requestData: {
          pageNum: 1,
          pageSize: 20,
          cloudMeetingId:null,
        },
        tableData: [],
        total: 0,
        drawerShow: false,
        drawerType: "add",
        initialData: {
          
        }
      };
    },
    //监控data中的数据变化
    watch: {},
    //计算属性，类似于data概念
    computed: {},
    //方法集合
    methods: {
      timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month =
          new Date(timeStamp).getMonth() + 1 < 10
            ? "0" + (new Date(timeStamp).getMonth() + 1)
            : new Date(timeStamp).getMonth() + 1;
        let date =
          new Date(timeStamp).getDate() < 10
            ? "0" + new Date(timeStamp).getDate()
            : new Date(timeStamp).getDate();
        let hh =
          new Date(timeStamp).getHours() < 10
            ? "0" + new Date(timeStamp).getHours()
            : new Date(timeStamp).getHours();
        let mm =
          new Date(timeStamp).getMinutes() < 10
            ? "0" + new Date(timeStamp).getMinutes()
            : new Date(timeStamp).getMinutes();
        let ss =
          new Date(timeStamp).getSeconds() < 10
            ? "0" + new Date(timeStamp).getSeconds()
            : new Date(timeStamp).getSeconds();
      
       return    year +"-" + month + "-" +  date +  " " +  " " +   hh +   ":" +   mm +  ":" +   ss;
      },
      searchData() {
        this.requestData.pageNum = 1;
        this.getList();
      },
      addClick() {
        this.drawerShow = true;
        this.drawerType = "add";
        this.initialData = {
          lectureUserName: "",
          lectureTeacherUnit: "",
          lectureBeau: "",
          lectureClass: "",
          lectureName: "",
          lectureContent: "",
          lectureImages: "",
          lectureFiles: "",
          organizationId: this.$store.getters.getUserInfo.schoolId,
          type:3
        };
      },
      handleCurrentChange(val) {
        this.requestData.pageNum = val;
        this.getList();
      },
      init(id){
        this.requestData.cloudMeetingId=id
        this.getList();
      },
      async getList() {
        let req = Object.assign({}, this.requestData);

        let res = await this.$Http.CloudMeetingList(req);
        if (res.code == 200) {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        } else if (res.code == 101) {
          this.tableData = [];
          this.total = 0;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message({
            type: "error",
            message: "查询失败"
          });
        }
      },
      editClick(info) {
        let text= info.cloudMeetingStatus==1?'关闭':'开启'
        this.$confirm(`确定要${text}当前会议吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          this.closeInfo(info)
        });
      },
       async closeInfo(info) {
        let form =new FormData()
        form.append('cloudMeetingStatus',info.cloudMeetingStatus==1?2:1)
        form.append('cloudMeetingId',info.cloudMeetingId)
  
        let res = await this.$Http.editCloudMeeting( form );
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.getList();
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "error",
            message: "操作失败"
          });
        }
      },
      checkInfo(info){
        this.drawerShow = true;
        this.drawerType = "info";
        this.initialData = {
          lectureUserName: info.lectureUserName,
          lectureTeacherUnit: info.lectureTeacherUnit,
          lectureBeau: info.lectureBeau,
          lectureClass: info.lectureClass,
          lectureName: info.lectureName,
          lectureContent: info.lectureContent,
          lectureImages: info.lectureImages,
          lectureFiles: info.lectureFiles,
          lectureId: info.lectureId,
        };
      },
      delClick(info) {
        this.$confirm("此操作将永久删除此记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          this.delInfo(info.cloudMeetingId);
        });
      },
      async delInfo(ids) {
        let res = await this.$Http.delCloudMeeting({ cloudMeetingId: ids });
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getList();
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "error",
            message: "删除失败"
          });
        }
      },
      handleClose() {
        this.drawerShow = false;
      },
      saveData(info) {
        if (this.drawerType == "add") {
          this.addInfo(info);
        } else {
          this.editInfo(info);
        }
      },
      async addInfo(info) {
        let req = Object.assign({}, info);
        let res = await this.$Http.addCloudMeeting(req);
        if (res.code == 200) {
          this.drawerShow = false;
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: "新增失败"
          });
        }
      },
      async editInfo(info) {
        let req = Object.assign({}, info);
        let res = await this.$Http.addCloudMeeting(req);
        if (res.code == 200) {
          this.drawerShow = false;
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: "编辑失败"
          });
        }
      },
       // 导出数据
      async exportData() {
        let req = {
          organizationId: this.$store.getters.getUserInfo.schoolId,
          type:3
        };
        this.$Common.exportData(req, "exportLectureRecords", "授课记录", true);
      },
      showLog(row){
            // CloudMeetingList
      }
    },
    //生命周期，创建完成（可以访问当前this实例）
    created() {},
    //生命周期，挂载完成（可以访问dom元素）
    mounted() {
     
    },
    beforeCreate() {}, //生命周期-创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之后
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroy() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>
  <style scoped></style>
  